$(document).ready(function(){
  console.log("working")
$('body').on('change','#gift-check',function() {
  console.log($(this).prop('checked'))
  if($(this).prop('checked')) {
    $(this).closest('.checkbox-wrapper').next('.gift-enabled').show(250, 'linear');
  }
  else{
    $(this).closest('.checkbox-wrapper').next('.gift-enabled').hide(250, 'linear');
    $('.gift-enabled').find('#message').val('');
  }
  $('#gift-check').val($(this).checked);        
});
})

// set tabs on search result page
$('.tabs-nav a').click(function() {

    // Check for active
    $('.tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');

    // Display active tab
    let currentTab = $(this).attr('href');
    $('.tabs-content .tabs-details').hide();
    $(currentTab).show();

    return false;
  });
$(document).ready(function(){
  var active = $('.tabs-nav').find('.active').find('a').attr('href');
  if($(active).children().length == 0){
    $(active).append('<p>No result found</p>');
  }
})